// extracted by mini-css-extract-plugin
module.exports = {"infoText":"AnonymousPaymentPage_infoText__sReHQ"};